import { Bid, Invoice } from '@bonhams1793/bonhams-typescript'

import { UserState } from './userState'

export function createUserState({
  activeBids,
  invoices,
  wonLots,
}: CreateUserStateProps) {
  const initialState: UserState = { user: { lots: {} } }

  wonLots.forEach((lotUniqueId) => {
    const relatedInvoice = invoices.find((invoice) =>
      invoice.lotUniqueIds?.includes(lotUniqueId)
    )

    initialState.user.lots[lotUniqueId] = {
      hasActiveBid: false,
      invoiceId: relatedInvoice?.invoiceId,
      lotUniqueId: String(lotUniqueId),
      won: true,
    }
  })

  activeBids.forEach((bid) => {
    initialState.user.lots[bid.lot_id] = {
      auctionId: bid.auction_id,
      bidAmount: bid.amount,
      bidId: bid.max_bid_id,
      hasActiveBid: true,
      lotUniqueId: String(bid.lot_id),
      paddleNo: bid.paddle_number,
      won: false,
    }
  })

  return initialState
}

interface CreateUserStateProps {
  activeBids: Bid[]
  invoices: Invoice[]
  wonLots: number[]
}
